import * as inputsAuth from '../../../core/components/input_manager/auth_inputs'
import { useLoadingContext } from '../../../core/context/loading/loading'
import { useAuth } from '../core/Auth';
import { useNavigate } from 'react-router-dom';
import { apiCaller } from '../../../core/hooks/useApi';
import { ServiceAgent } from '../../../core/services/serviceAgent';
import { toast } from 'react-toastify';


export function Login() {

  const { handleClose, handleOpen, showLoading } = useLoadingContext();
  const { saveToken, saveUserInfo, setUserInfo } = useAuth()
  const navigate = useNavigate()
  const {
    Input: userNameInput,
    Value: userNameValue,
    validate: userNameValid,
  } = inputsAuth.useUserNameInput({
    className: 'mb-1',
    initialvalue: ''
  })
  const {
    Input: passwordInput,
    Value: passwordValue,
    validate: passwordValid,
  } = inputsAuth.usePasswordInput({
    className: '',
    initialvalue: ''
  })
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    const v1 = await userNameValid()
    const v2 = await passwordValid()

    if (v1 && v2) {
      apiCaller({
        api: ServiceAgent.auth.request_login,
        apiArguments: { username: userNameValue, password: passwordValue },
        onStart: handleOpen,
        onEnd: handleClose,
        onError: (resp) => {
          saveToken(undefined)
          saveUserInfo(undefined)
        },
        onSuccess: (resp) => {
          if (resp.status == 200 && resp?.data?.statusCode == 200 && resp.data?.data?.token) {
            saveToken(resp.data?.data?.token)
            setUserInfo({ ...resp?.data?.data })
            navigate('/dashboard')
          }
        },
        onSuccessMessage: 'ورود با موفقیت انجام شد',
      })
    }
  }



  return (
    <form
      className='form w-100'
      onSubmit={handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>ورود</h1>
        <div className='text-gray-500 fw-semibold fs-6'>پنل مدیریت صندوق پژوهش استان مرکزی</div>
      </div>
      {/* begin::Heading */}



      {/* begin::Separator */}
      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>ورود با نام کاربری</span>
      </div>
      {/* end::Separator */}

      {userNameInput()}

      {passwordInput()}

      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
        >
          {!showLoading && <span className='indicator-label'>ورود</span>}
          {showLoading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              لطفا صبر کنید...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}
